import * as React from 'react';
import moment from 'moment-timezone';
import actions from 'store/notifications/actions';
import {
  DISPLAY_NOTIFICATION_CRITICAL,
  DISPLAY_NOTIFICATION_INFO,
  DISPLAY_NOTIFICATION_WARNING,
  NOTIFICATION_TYPE,
  NOTIFICATION_TYPE_1,
  NOTIFICATION_TYPE_2,
  NOTIFICATION_TYPE_3,
  NOTIFICATION_TYPE_4,
  TOOLTIP_TYPE,
} from './consts';

export const getTooltipTypeByDisplayNotificationType = (label) => {
  if (
    `NOTIFICATION_TYPE_${label}` === NOTIFICATION_TYPE_1 ||
    `NOTIFICATION_TYPE_${label}` === NOTIFICATION_TYPE_2
  ) {
    return DISPLAY_NOTIFICATION_CRITICAL;
  }
  if (
    `NOTIFICATION_TYPE_${label}` === NOTIFICATION_TYPE_3 ||
    `NOTIFICATION_TYPE_${label}` === NOTIFICATION_TYPE_4
  ) {
    return DISPLAY_NOTIFICATION_WARNING;
  }
  return DISPLAY_NOTIFICATION_INFO;
};

export const getLabelClass = (labelKey) => {
  if (labelKey === DISPLAY_NOTIFICATION_CRITICAL)
    return 'notification-label--critical';
  if (labelKey === DISPLAY_NOTIFICATION_WARNING)
    return 'notification-label--warning';
  return 'notification-label--info';
};

export const renderNotificationLabel = (labelKey, isShowInModal) => {
  const className = getLabelClass(
    getTooltipTypeByDisplayNotificationType(labelKey)
  );
  return (
    <div
      className={`notification-label ${
        isShowInModal ? 'is-in-modal' : ''
      } ${className}`}
    >
      <span>{NOTIFICATION_TYPE[`NOTIFICATION_TYPE_${labelKey}`]}</span>
    </div>
  );
};

export const renderNotificationTooltipTitle = (
  labelType,
  message = '',
  count = 0
) => {
  if (labelType === DISPLAY_NOTIFICATION_CRITICAL) {
    return TOOLTIP_TYPE.CRITICAL();
  }
  if (labelType === DISPLAY_NOTIFICATION_WARNING) {
    return TOOLTIP_TYPE.WARNING(message);
  }
  return TOOLTIP_TYPE.INFO(count);
};

export const handleHoverNotificationIcon = (isNotReadArr, dispatch) => {
  if (isNotReadArr.length === 0) {
    dispatch(
      actions.toggleTooltip({
        isShow: true,
        message: 'お知らせ',
        type: 'hover',
      })
    );
    return;
  }
  const notReadPriority = isNotReadArr.find((item) => item.priority);
  if (notReadPriority) {
    dispatch(
      actions.toggleTooltip({
        isShow: true,
        message: renderNotificationTooltipTitle(DISPLAY_NOTIFICATION_CRITICAL),
        type: 'hover',
      })
    );
  } else {
    dispatch(
      actions.toggleTooltip({
        isShow: true,
        message: renderNotificationTooltipTitle(
          DISPLAY_NOTIFICATION_INFO,
          '',
          isNotReadArr.length
        ),
        type: 'hover',
      })
    );
  }
};

// Utility to convert camelCase keys to snake_case
export const toSnakeCaseObject = (obj) => {
  const result = {};
  Object.keys(obj).forEach((key) => {
    const snakeKey = key.replace(
      /[A-Z]/g,
      (letter) => `_${letter.toLowerCase()}`
    );
    result[snakeKey] = obj[key];
  });
  return result;
};

export const handleStorageTrackingData = ({
  action,
  accountId,
  userId,
  modalId = null,
  modalType = null,
  openTimestamp = null,
  closeTimestamp = null,
  auto = null,
  date = null,
}) => {
  if (action === 'modal_click' && modalId) {
    return toSnakeCaseObject({
      action,
      accountId,
      userId,
      modalId,
      modalType,
      openTimestamp,
      closeTimestamp,
      auto,
      date,
    });
  }

  if (action === 'tooltip_click' || action === 'tooltip_display') {
    return toSnakeCaseObject({ action, accountId, userId, date });
  }

  // Default return to avoid undefined
  return {};
};

// Utility to get ISO string in GMT+9 (JST)
export const getGMT9ISOString = () => {
  return moment().tz('Asia/Tokyo').format('YYYY-MM-DDTHH:mm:ssZ');
};
